import { ErrorAppearance, ErrorMessageWrapper } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { getErrorDataHook } from '../../services/field-attributes';
import { classes } from './field-error-wut.st.css';
export const FieldErrorWUT = ({ target, hasError, errorMessage, id })=>{
    return /*#__PURE__*/ React.createElement(ErrorMessageWrapper, {
        className: classes.root,
        visible: Boolean(hasError),
        message: errorMessage ?? '',
        "data-hook": getErrorDataHook(target),
        messageId: id,
        errorAppearance: ErrorAppearance.TextOnly
    });
};

//# sourceMappingURL=field-error-wut.js.map